import { useState } from "react";
export default function CheckIsLogged() {
    let usn = localStorage.getItem("usn");
    let psw = localStorage.getItem("psw");
    const [userInfo, setUserInfo] = useState(usn && psw ? {usn,psw} : null);

    return { userInfo ,setUserInfo};
}